import { createAppStore } from './createAppStore'
import { registerStore } from './storeRegistry'

const { store, engines } = createAppStore()
registerStore(store)

export { store, engines }
export default store
